import { render, staticRenderFns } from "./TemplatesLanguageSelector.vue?vue&type=template&id=50b95627&scoped=true"
import script from "./TemplatesLanguageSelector.vue?vue&type=script&lang=js"
export * from "./TemplatesLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./TemplatesLanguageSelector.vue?vue&type=style&index=0&id=50b95627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b95627",
  null
  
)

export default component.exports